<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Employee Benefits 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        show-empty
      >
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col lg="7">
        <b-card >
            <div slot="header">Employee Benefits - Add/Edit Form </div>
                  <b-input-group>
                        <b-input-group-prepend><label>Benefit Name</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.NmClaim" :state="!$v.frmdata.NmClaim.$error"></b-form-input>
                  </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Period New Plafon</label></b-input-group-prepend>
                      <b-form-radio-group  v-model="frmdata.ResetFreq" name="radioResetFreq" class="mt-1" >
                          <b-form-radio :value="0">Sekali Seumur</b-form-radio>
                          <b-form-radio :value="-1">per Klaim</b-form-radio>
                      </b-form-radio-group>
                      <b-input-group-prepend><span  class="ml-3 pt-1 mr-2">Periode</span></b-input-group-prepend>
                      <b-form-input v-model="frmdata.ResetFreq" type="number" :state="!$v.frmdata.ResetFreq.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text"><b>bulan</b></span></b-input-group-prepend>
                  </b-input-group>
                  <b-input-group>
                      <b-input-group-prepend><label>Maximum Claim</label></b-input-group-prepend>
                      <b-form-radio-group  v-model="frmdata.MaxClaim" name="radioMaxClaim" class="mt-1" >
                          <b-form-radio :value="0">Tidak terbatas selama dlm Plafon</b-form-radio>
                      </b-form-radio-group>
                      <b-input-group-prepend><span  class="ml-3 pt-1 mr-2">Jumlah klaim dlm satu plafon</span></b-input-group-prepend>
                      <b-form-input v-model="frmdata.MaxClaim" type="number" :state="!$v.frmdata.MaxClaim.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text"><b>kali</b></span></b-input-group-prepend>
                  </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Paid per Claim</label></b-input-group-prepend>
                      <b-form-input v-model="frmdata.PaidPerClaim" type="number" :state="!$v.frmdata.PaidPerClaim.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">% * reimbursement amount</span></b-input-group-prepend>
                        <b-form-radio-group  v-model="frmdata.PayMethod" name="radioIndividu" class="ml-2 mt-1" :state="!$v.frmdata.PayMethod.$error">
                            <b-form-radio value="With Payroll">Dibayar bersama Gaji</b-form-radio>
                            <b-form-radio value="After Payroll">Terpisah dari Gajian</b-form-radio>
                        </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Salary Item</label></b-input-group-prepend>
                        <b-form-input readonly v-model="frmdata.NmKompGaji" :state="!$v.frmdata.IdKompGaji.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSalaryitemShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
      <b-modal v-model="lkuSalaryitemShow" size="lg" :hide-footer="true" title="List of Salary Items" :centered="true" :lazy="true">
          <lku-salaryitem @click="onSelectLkuSalaryitem" ></lku-salaryitem>
      </b-modal>        

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import lkuSalaryitem from '../lookup/lkuSalaryitem';
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuSalaryitem},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        IdKompGaji: { required },
        NmClaim: { required },
        PayMethod: { required },
        ResetFreq: { required },
        MaxClaim: { required },
        PaidPerClaim: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{NmClaim: '' },
      tblData: {
        tablename:'benefitvw',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
      lkuSalaryitemShow:false,
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "NmClaim",
            label: "Benefit Name",
            sortable: true
          },
          {
            key: "ResetKali",
            label: "Period New Plafon (in Month)",
            sortable: true
          },
          {
            key: "MaxKali",
            label: "Max. Claim Times per Period Plafon",
            sortable: true
          },
          {
            key: "PaidPerClaim",
            label: "% Penggantian Biaya per Claim",
            sortable: true
          },
          {
            key: "PayMethod",
            label: "Payment Method"
          },
          {
            key: "NmKompGaji",
            label: "Salary Item Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    onSelectLkuSalaryitem: function(_selected){
        this.frmdata.IdKompGaji =_selected.IdKompGaji;
        this.frmdata.NmKompGaji =_selected.NmKompGaji;
        // KdKompGaji
        this.lkuSalaryitemShow=false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        this.frmdata.PaidPerClaim=100;
    this.frmdata.PayMethod=`With Payroll`;
    this.frmdata.ResetFreq=12;        
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.ClaimID;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'benefit', 
                     key:this.frmdata.idlama, 
                     data:{IdKompGaji:this.frmdata.IdKompGaji, 
                        NmClaim:this.frmdata.NmClaim,                   
                        ResetFreq:this.frmdata.ResetFreq,                   
                        MaxClaim:this.frmdata.MaxClaim,                   
                        PaidPerClaim:this.frmdata.PaidPerClaim,                   
                        PayMethod:this.frmdata.PayMethod}
                      });
              } else {
                await crud.insert(
                  { tablename:'benefit',                      
                     data:{IdKompGaji:this.frmdata.IdKompGaji, 
                        NmClaim:this.frmdata.NmClaim,                   
                        ResetFreq:this.frmdata.ResetFreq,                   
                        MaxClaim:this.frmdata.MaxClaim,                   
                        PaidPerClaim:this.frmdata.PaidPerClaim,                   
                        PayMethod:this.frmdata.PayMethod}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'komponengaji', key:this.model.ClaimID});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
